// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-picker-group[data-v-ddb53056] {\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n}\n.date-picker-group .start-date-picker[data-v-ddb53056] {\n  display: inline-block;\n  width: 48%;\n  float: left;\n}\n.date-picker-group .end-date-picker[data-v-ddb53056] {\n  display: inline-block;\n  width: 48%;\n  float: right;\n}\n.date-picker-group .el-input--suffix .el-input__inner[data-v-ddb53056] {\n  padding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
